//TODO: GROW-2166 when Productizing if fixed win update the InverseHeader in core component and fix imports
'use client';

import InverseHeader from '@/app/components/Experiments/FixedHeader/InverseHeader/InverseHeader';
import useScrollTracking from '@/app/hooks/useScrollTracking';

import MachineLearningJumbotron from './_components/MachineLearningJumbotron';
import ScienceAndResearchAdvisor from './_components/ScienceAndResearchAdvisor';
import ScienceAndResearchCallout from './_components/ScienceAndResearchCallout';
import ScienceAndResearchCards from './_components/ScienceAndResearchCards';
import ScienceAndResearchFooter from './_components/ScienceAndResearchFooter';
import ScienceAndResearchHero from './_components/ScienceAndResearchHero';
import ScienceAndResearchInnovation from './_components/ScienceAndResearchInnovation';
import ScienceAndResearchIntegrations from './_components/ScienceAndResearchIntegrations';
import ScienceAndResearchJumbotron from './_components/ScienceAndResearchJumbotron';
import ScienceAndResearchMedicalAdvisors from './_components/ScienceAndResearchMedicalAdvisors';
import ScienceAndResearchUniversities from './_components/ScienceAndResearchUniversities';

const Content = (): JSX.Element => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return (
    <>
      <ScienceAndResearchHero />
      <ScienceAndResearchInnovation />
      <ScienceAndResearchIntegrations />
      <ScienceAndResearchCallout />
      <MachineLearningJumbotron />
      <ScienceAndResearchAdvisor />
      <ScienceAndResearchJumbotron />
      <ScienceAndResearchCards />
      <ScienceAndResearchUniversities />
      <InverseHeader enter>
        <ScienceAndResearchMedicalAdvisors />
        <ScienceAndResearchFooter />
      </InverseHeader>
    </>
  );
};

export default Content;
